/**
 * @generated SignedSource<<8c8442df295beb081a9facd7adec6f99>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedAuctionSecondChanceOffer_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedBuyItNowButton_user">;
  readonly " $fragmentType": "PdpSharedAuctionSecondChanceOffer_user";
};
export type PdpSharedAuctionSecondChanceOffer_user$key = {
  readonly " $data"?: PdpSharedAuctionSecondChanceOffer_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAuctionSecondChanceOffer_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedAuctionSecondChanceOffer_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedBuyItNowButton_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "7b0094af8318bcaa843538af4fe0e653";

export default node;
